export const ellipsize = (input?: string) => {
  if (input && input.length > 125) {
    return input.substring(0, 125) + "...";
  }
  return input;
};
